export default __webpack_public_path__ + "static/media/fsk-22-b.8441f9d3.jpg";